<template>
  <div class="propriedades_feixe">
    <div class="form-group">
      <label for="TituloSimulacao">Título da Simulação</label>
      <input
        @change="defineVariaveis"
        type="text"
        class="form-control"
        id="TituloSimulacao"
        placeholder="Título para simulação"
        v-model="title"
      />
    </div>
    <div class="conteudo" id="conteudo-propriedades_feixe">
      <div class="form-group">
        <label for="input_type">Selecione o tipo de Feixe:</label>
        <select @change="defineVariaveis" v-model="tipo_feixe" class="form-control" id="input_type">
          <option value disabled selected>Tipos de feixe</option>
          <option disabled value="gaus">Feixe de Gaus</option>
          <option value="bessel">Feixe de Bessel</option>
          <option disabled value="frozen">Frozen Wave</option>
          <option disabled value="exponencial">Exponencial</option>
          <option disabled value="outros">Outros</option>
        </select>
      </div>
      <div class="form-group">
        <label for="select_propriedade">Propriedade:</label>
        <select
          @change="defineVariaveis"
          v-model="propriedade_feixe"
          class="form-control"
          id="select_propriedade"
        >
          <option disabled value="forca">Força</option>
          <option value="campo" selected>Campo</option>
        </select>
      </div>
      <div class="form-group">
        <label for="lambda">Comprimento da onda</label>
        <input
          @change="defineVariaveis"
          type="number"
          class="form-control"
          id="lambda"
          placeholder="λ em (nM)"
          v-model="comprimento_onda"
        />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "propriedadeFeixe",
  data() {
    return {
      tipo_feixe: "",
      comprimento_onda: 1024e-9,
      propriedade_feixe: "campo",
      title: 'Intensidade do Campo Elétrico'
    };
  },
  methods: {
    defineVariaveis: function() {
      this.$emit("select_tipo_feixe", {
        dados: {
          tipo_feixe: this.tipo_feixe,
          propriedade_feixe: this.propriedade_feixe,
          comprimento_onda: this.comprimento_onda,
          title:this.title
        }
      });
    }
  }
};
</script>